import { Component, ElementRef, NgZone, OnInit, TemplateRef, ViewChild} from "@angular/core";
import { FormGroup,  FormBuilder, Validators, FormArray } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import * as CONSTANT from "../../services/constants";

@Component({
  selector: "app-language",
  templateUrl: "./language.component.html",
  styleUrls: ["./language.component.css"]
})
export class LanguageComponent implements OnInit {
  modalRef?: BsModalRef;
  form: FormGroup;
  showError = false;
  sameErrorPosition = -1;
  allLangue;
  Languages:any=CONSTANT.Languages;
  dropdownLanguageSettings:any;
  constructor(private modalService: BsModalService,private formBuilder: FormBuilder,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService) {
    this.form = formBuilder.group({
      languageProficiency: formBuilder.array([])
    })

    this.addNewLanguageGroup()
   }

  ngOnInit(): void {
    this.getLanguages();
    this.dropdownLanguageSettings = {
			singleSelection: true,
			idField: "name",
			textField: "name",
			itemsShowLimit: 1,
			allowSearchFilter: true,
		};
  }
  newLanguage(): FormGroup {
    return this.formBuilder.group({
      language: ["", Validators.compose([Validators.required])],
      proficiency: ["", Validators.compose([Validators.required])]
    })
  }

  getLanguagesArray() {
    return (this.form.get("languageProficiency") as FormArray).controls;
  }

  checkLanguageEmpty(i) {
    return (this.form.get("languageProficiency") as FormArray).controls[i].get("language")?.hasError("empty");
  }
  checkLanguageDuplicate(i) {
    return (this.form.get("languageProficiency") as FormArray).controls[i].get("language")?.hasError("duplicate");
  }

  checkProficiencyEmpty(i) {
    return (this.form.get("languageProficiency") as FormArray).controls[i].get("proficiency")?.hasError("empty");
  }

  addNewLanguageGroup() {
    let languages = this.form.controls["languageProficiency"] as FormArray;
    languages.push(this.newLanguage())
  }
  getLanguages(){
    this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getLanguage)
    .subscribe(async (res) => {
      this.allLangue = res.data;
      if (this.allLangue.length > 0) {
        let languages = this.form.controls["languageProficiency"] as FormArray;
        languages.clear();
        this.allLangue.map((language)=>{ 
          languages.push(
            this.formBuilder.group({
              language: [[{name: language.language}], Validators.compose([Validators.required])],
              proficiency: [language.proficiency, Validators.compose([Validators.required])]
            })
          )
        })
      } 
      
    })
  }
  deleteLanguage(i){ 
    this.getLanguagesArray().splice(i,1);
  }
  // on submit
  onSubmit(){ 
    // if(this.form.valid){
      let languages : FormArray = this.form.controls["languageProficiency"] as FormArray;
      let languageProficiencies : any = []

      const langSet = new Set<string>();

      for(let i=0; i < languages.controls.length; i++) {
        
        let langGroup = languages.controls[i];
        const langControl = langGroup.get("language");
        
        const proficiencyControl = langGroup.get("proficiency");
        if(langControl?.value.length == 0){
          this.showError = true;
          langControl?.setErrors({ empty : true})
        } else{
          
        const language = langControl?.value[0].name;

        const stringArray = Array.from(langSet);

        if (stringArray.some(str => str.toLowerCase() === language.toLowerCase())) {
          this.showError = true;
          langControl?.setErrors({ duplicate : true})
        } else {
          langSet.add(language);
          langControl?.setErrors(null);
         
        }
        }

        if(proficiencyControl?.value == ""){
          this.showError = true;
          proficiencyControl?.setErrors({ empty : true})
        }

        if (langControl?.valid && proficiencyControl?.valid) {
          languageProficiencies.push({
            language: langControl?.value[0].name,
            proficiency: langGroup.get("proficiency")?.value
          })
        }
      }

      if (this.showError) {
        setTimeout(() => {
          this.showError = false;
        }, 3000);
        return;
      }

      let data = {
        languageProficiency: languageProficiencies
    };
      this.api.postData(apiUrl._addLanguageMultiple, data)
      .subscribe(async (res) => {
        this.toastrService.success("", "Language added successfully.");
        // this.router.navigate(["/language/add"]);
        this.router.navigate(["/jobs"]);
      })
    // } else{
    //   this.showError= true;
    //   setTimeout(() => {
    //     this.showError= false;
    //   }, 3000);
    // }
    
  }
}

